module.exports = __webpack_public_path__ + "static/img/weichat.9c387088.png";